import {VisibilityConfigDef, visibilityDef, VisibilityFlag} from "./VisibilityConfigDef";
import {AtomContainer} from "@alchemiesolns/atomcontainer"

export const visibilityConfig = {
    decode: (config: string) => {
        const parts = config.split("|");
        const visibilitySection = parts.find(part => part.startsWith("vis*"));
        if(visibilitySection) {
            const visibilityReps = visibilitySection.slice("vis*".length).split(",");
            return visibilityReps.map(s => visibilityDef.decode(s)).filter(d => d !== null);
        }
        return [];
    },
    encode: (visDefs: VisibilityConfigDef[]) => {
        const visibilityReps = visDefs.map(vis => visibilityDef.encode(vis));
        if(visibilityReps.length === 0) {
            return "";
        }
        const visibilityString = visibilityReps.join(",");
        return "|vis*" + visibilityString;
    },
    /**
     * Apply visibility configuration to an AtomContainer's atoms
     * Sets atom.visible property based on visibility flags
     *
     * @param visDefs - Array of visibility configurations
     * @param atomContainer - AtomContainer to apply visibility to
     */
    applyVisibilityToContainer: (visDefs: VisibilityConfigDef[], atomContainer: any) => {
        // First, set all atoms to visible (default state)
        atomContainer.atoms.forEach((atom: any) => {
            atom.visible = true;
        });

        // Apply visibility flags from visDefs
        visDefs.forEach((visDef) => {
            const atomIndex = visDef.a;
            if (atomIndex >= 0 && atomIndex < atomContainer.atoms.length) {
                // Only Hidden flag makes atoms invisible
                // HiddenLP only hides lone pairs, not the atom itself
                if (visDef.visibilityFlag === VisibilityFlag.Hidden) {
                    atomContainer.atoms[atomIndex].visible = false;
                }
            }
        });
    },
    /**
     * Extract visibility configuration from an AtomContainer's atoms
     * Generates visDefs array from atom.visible properties
     *
     * @param atomContainer - AtomContainer to extract visibility from
     * @param previousVisDefs - Previous visibility configuration to preserve HiddenLP flags
     * @returns Array of visibility configurations
     */
    extractVisibilityFromContainer: (atomContainer: AtomContainer, previousVisDefs?: VisibilityConfigDef[]): VisibilityConfigDef[] => {
        const visDefs: VisibilityConfigDef[] = [];

        // console.log('[extractVisibilityFromContainer] previousVisDefs:', previousVisDefs);

        atomContainer.atoms.forEach((atom: any, index: number) => {
            // Check if this atom was previously configured
            const previousVisDef = previousVisDefs?.find(v => v.a === index);

            if (atom.visible === false) {
                // Atom is hidden
                // console.log(`[extractVisibilityFromContainer] Atom ${index}: visible=false → Hidden`);
                visDefs.push({
                    a: index,
                    visibilityFlag: VisibilityFlag.Hidden
                });
            } else if (previousVisDef?.visibilityFlag === VisibilityFlag.HiddenLP) {
                // Atom is visible but has hidden lone pairs - preserve this state
                // console.log(`[extractVisibilityFromContainer] Atom ${index}: visible=true, previousVisDef has HiddenLP → HiddenLP`);
                visDefs.push({
                    a: index,
                    visibilityFlag: VisibilityFlag.HiddenLP
                });
            } else {
                // console.log(`[extractVisibilityFromContainer] Atom ${index}: visible=${atom.visible}, previousVisDef=${previousVisDef?.visibilityFlag} → skip`);
            }
            // If fully visible (no previous visDef or visible with no special flags), don't add an entry
        });

        // console.log('[extractVisibilityFromContainer] result visDefs:', visDefs);
        return visDefs;
    }
}